var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPxCalendarPic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "12px",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "px-calendar-small") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "3.-Vimcar-\\u2013-Book-n-Drive-\\u2013-CleverShuttle-configuration",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "5f.-Car-parts-selection-\\u2013-side-details-\\u2013-cheking-\\u2013-Vimcar-configuration",
    transform: "translate(-275.000000, -230.000000)",
    fill: "#6B6E85"
  }, /*#__PURE__*/React.createElement("g", {
    id: 1,
    transform: "translate(16.000000, 199.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M267.5,31 C267.762993,31 267.97619,31.2131977 267.97619,31.4761905 L267.976,32 L269,32 C270.104569,32 271,32.8954305 271,34 L271,41 C271,42.1045695 270.104569,43 269,43 L261,43 C259.895431,43 259,42.1045695 259,41 L259,34 C259,32.8954305 259.895431,32 261,32 L262.023,32 L262.02381,31.4761905 C262.02381,31.2131977 262.237007,31 262.5,31 C262.762993,31 262.97619,31.2131977 262.97619,31.4761905 L262.976,32 L267.023,32 L267.02381,31.4761905 C267.02381,31.2131977 267.237007,31 267.5,31 Z M262.023,33 L261,33 C260.447715,33 260,33.4477153 260,34 L260,34 L260,41 C260,41.5522847 260.447715,42 261,42 L261,42 L269,42 C269.552285,42 270,41.5522847 270,41 L270,41 L270,37 L262.5,37 C262.223858,37 262,36.7761424 262,36.5 C262,36.2238576 262.223858,36 262.5,36 L270,36 L270,34 C270,33.4871642 269.61396,33.0644928 269.116621,33.0067277 L269,33 L267.976,33 L267.97619,33.5238095 C267.97619,33.7868023 267.762993,34 267.5,34 C267.237007,34 267.02381,33.7868023 267.02381,33.5238095 L267.023,33 L262.976,33 L262.97619,33.5238095 C262.97619,33.7868023 262.762993,34 262.5,34 C262.237007,34 262.02381,33.7868023 262.02381,33.5238095 L262.023,33 Z",
    id: "px-calendar-small"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPxCalendarPic);
export default __webpack_public_path__ + "static/media/px-calendar-pic.51fe455ed9fcc7a51d43482312752616.svg";
export { ForwardRef as ReactComponent };